
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useRouteMatch } from "react-router";
import { useDispatch } from "react-redux";
import { KTextInput, KSelect } from "@kyburz/kdesign-system";
import useSetState from "../../hooks/useSafeSetState";
import BaseLayout from "../../components/layouts/BaseLayout";
import KSwitch from "../../components/ui/button/switch";
import KSelectDevice from "../../components/KSelectDevice";
import KFormBackground from "../../components/ui/KFormBackground";
import JsonTextInput from "../../components/JsonTextInput";
import {
  updateVehicle,
  getVehicle,
  deleteVehicle,
} from "../../apiCalls/config/vehicles";
import { setAlert } from "../../redux/actions/actions";
import { getCustomers } from "../../apiCalls/auth";

const VehicleView: React.FC = () => {
  const dispatch = useDispatch();
  const history: any = useHistory();

  const match = useRouteMatch({
    path: "/config/vehicles/:vehicleId",
    strict: true,
    sensitive: true,
  });

  // eslint-disable-next-line prefer-destructuring
  const vehicleId = (match?.params as any).vehicleId;

  const [
    {
      customer,
      vehicleName,
      active,
      firstDevice,
      secondDevice,
      apiFetch,
      apiPush,
      vehicle_params,
      formControlCustomers,
    },
    setState,
  ] = useSetState({
    customer: "",
    vehicleName: "",
    active: true,
    firstDevice: "",
    secondDevice: "",
    apiFetch: false,
    apiPush: false,
    vehicle_params: {},
    formControlCustomers: [],
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res: any = await updateVehicle(
      customer,
      vehicleId,
      vehicleName,
      firstDevice || null,
      secondDevice,
      active,
      apiFetch,
      apiPush,
      vehicle_params || {},
    );
    if (res.errors) {
      setState({ errors: res.errors });
    } else {
      setState({
        customer,
        vehicleId,
        vehicleName: res.data.name,
        active: res.data.active,
        firstDevice: res.data.imei,
        secondDevice: res.data.imei2,
        apiFetch: res.data.api_fetch,
        apiPush: res.data.api_push,
        vehicle_params: res.data.vehicle_params,
      });
      dispatch(setAlert("Saved successfully", "success"));
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    const res = await deleteVehicle(vehicleId);
    if (res.detail) {
      dispatch(setAlert(res.detail, "error"));
    } else {
      history.push("/config/vehicles");
      dispatch(setAlert("Vehicle deleted", "success"));
    }
  };

  useEffect(() => {
    getVehicle(vehicleId).then((res) =>
      res && res.data
        ? setState({
          customer: res.data.customer,
          vehicleId,
          vehicleName: res.data.name,
          active: res.data.active,
          firstDevice: res.data.imei,
          secondDevice: res.data.imei2,
          apiFetch: res.data.api_fetch,
          apiPush: res.data.api_push,
          vehicle_params: res.data.vehicle_params,
        })
        : null,
    );
    getCustomers().then((res) =>
      setState({
        formControlCustomers: res.data
          .filter((el) => el._id !== null)
          .map((el) => ({ label: el.shortname })),
      }),
    );
  }, []);

  const handleChange = (e) => setState({ [e.target.name]: e.target.value });

  const handleSelectFirstDevice = (e, value) =>
    setState({ firstDevice: value });
  const handleCustomerSelect = (value) => setState({ customer: value.label });
  const handleJsonChangeVehicleParams = (code) =>
    setState({ vehicle_params: code });

  const handleToggle = (e) => setState({ [e.target.name]: e.target.checked });

  return (
    <BaseLayout
      title={`Edit Vehicle ${vehicleId}`}
      handleArrowClick={() => history.push("/config/vehicles")}
    >
      <KFormBackground
        size="large"
        primaryCTAColor="primary"
        primaryCTAonClick={handleSubmit}
        primaryCTAText="Save"
        secondaryCTAText="Cancel"
        secondaryCTAonClick={() => history.goBack()}
        dangerCTAText="Delete"
        dangerCTAonClick={handleDelete}
      >
        <div>
          <KTextInput
            label="Id"
            name="vehicleId"
            value={vehicleId}
            onChange={handleChange}
            width="320px"
            disabled={true}
            style={{ marginRight: "24px" }}
          />
        </div>
        <div style={{ display: "flex" }}>
          <KTextInput
            label="Name"
            name="vehicleName"
            value={vehicleName}
            onChange={handleChange}
            style={{ display: "inline-block", marginRight: "24px" }}
          />
          <KSelect
            label="Customer"
            value={customer}
            onSelect={handleCustomerSelect}
            elements={formControlCustomers}
            style={{ marginRight: "24px" }}
          />
          <KSwitch
            name="active"
            onChange={handleToggle}
            checked={active}
            label="Active"
            switchLabel=""
            style={{ display: "inline-block" }}
          />
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ display: "inline-block", marginRight: "24px" }}>
            <KSelectDevice
              label="Connected Devices"
              name="firstDevice"
              value={firstDevice}
              onChange={handleSelectFirstDevice}
              placeholder="Select Device #1..."
            />
          </div>
          <div>
            <KSwitch
              name="apiFetch"
              onChange={handleToggle}
              checked={apiFetch}
              label="API Fetch"
              style={{ display: "inline-block" }}
            />
            <KSwitch
              name="apiPush"
              onChange={handleToggle}
              checked={apiPush}
              label="API Push"
              style={{ display: "inline-block" }}
            />
          </div>
        </div>
        <JsonTextInput
          label="Vehicle Parameters"
          value={vehicle_params}
          handleSubmit={handleJsonChangeVehicleParams}
        />
      </KFormBackground>
    </BaseLayout>
  );
};

export default VehicleView;
